var _path, _path2, _polygon, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorFireExtinguisher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.023,11.666v-1.69l-8.093-3.405,6.037-1.426.048-1.979-10.226,2.356v1.443h-2.698v2.29h2.698v2.627c-1.142.288-2.227.864-3.137,1.733h0v25.22h9.724V13.614c-.96-.916-2.114-1.508-3.325-1.778v-3.267l8.971,3.096Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.092,8.156c-13.864,0-8.908,10.54-8.908,16.374"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "12.284 36.576 7.977 36.576 9.566 24.53 10.695 24.53 12.284 36.576"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28.376,
    y1: 21.459,
    x2: 19.092,
    y2: 21.459
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28.376,
    y1: 30.553,
    x2: 19.092,
    y2: 30.553
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorFireExtinguisher);
export default __webpack_public_path__ + "static/media/indoor-fire_extinguisher.43fa4a9abed065a9c7b23b0f91ad3b44.svg";
export { ForwardRef as ReactComponent };